<template>
	<div>
		<div class="filter-tag-row">
			<ReFilterBtn v-model="bShowFilter" :bShowOptsCount="false"/>
			<span class="ml-3 el-tag el-tag--small el-tag el-tag--plain el-tag--primary">Клиенты: {{this.masApi_total}}</span>
		</div>
		<!-- <div class="row" v-show="bShowFilter">
			<div class="col-12"><ReFilter :masAllFilterParams="masAllFilterParams" v-model="objGetParams" v-on:filterapply="OnFilterApply"/></div>
		</div> -->

		<div v-show="bShowFilter">
		<ReClientMultiOpFilter @change="OnFilterApply" />
		</div>
		<!-- 
		<card class="majorFilter-card filter"  @change="OnFilterApply">
			<div class="filter-options">
				<div class="filter-options-group px-0 col-md-12">
					<div class="row" >
						<label class="col-form-label col-md-3">По клиенту</label>
						<div class="form-group col-md-9">
							<ReSearchStaffClients 
								placeholder="ФИО сотрудника"
								placeholder_otdel="Название отдела"
								v-model="objFilterData.structure.value"
								:objApiMethod="{'obj':'staff','flt':{'fio':''}}"
								:strApiMethodKey="'fio'"
								:objApiMethod_otdel="{'obj':'structures','flt':{'name':''}}"
								:strApiMethodKey_otdel="'name'"
								:rb_options="objFilterData.structure.rb_options"
								v-on:change="OnAjaxListSearch"
							/>
						</div>
					</div>
					<div class="row">
						<label class="col-form-label col-md-3">По наличию услуг</label>
						<div class="col-md-9 checkbox-radios">
							<base-radio v-for="(el_opt, el_index) in objFilterData.rb_service.options" 
							:name="el_opt.value" 
							:label="el_opt.label" 
							v-model="objFilterData.rb_service.value" 
							inline>{{el_opt.label}}</base-radio>
						</div>
					</div>

					<div class="row" v-if="this.objFilterData.rb_service.value != 2 ">
						<label class="col-form-label col-md-3">Включить статусы услуги</label>
						
						<div class="col-md-9 checkbox-radios">
							<base-checkbox v-model="objFilterData.srv_oncontrol.value" inline :disabled="objFilterData.srv_oncontrol_excl.value"
							>На контроле</base-checkbox>
							<base-checkbox v-model="objFilterData.srv_new.value" inline :disabled="objFilterData.srv_new_excl.value">Новые</base-checkbox>
							<base-checkbox v-model="objFilterData.srv_inwork.value" inline :disabled="objFilterData.srv_inwork_excl.value">В работе</base-checkbox>
							<base-checkbox v-model="objFilterData.srv_sdelka.value" inline :disabled="objFilterData.srv_sdelka_excl.value">Сделка</base-checkbox>
							<base-checkbox v-model="objFilterData.srv_arhiv.value" inline :disabled="objFilterData.srv_arhiv_excl.value">Архив</base-checkbox>
						</div>
						<label class="col-form-label col-md-3">Исключить статусы услуги</label>
						<div class="col-md-9 checkbox-radios">
							<base-checkbox v-model="objFilterData.srv_oncontrol_excl.value" inline :disabled="objFilterData.srv_oncontrol.value"
							>На контроле</base-checkbox>
							<base-checkbox v-model="objFilterData.srv_new_excl.value" inline :disabled="objFilterData.srv_new.value">Новые</base-checkbox>
							<base-checkbox v-model="objFilterData.srv_inwork_excl.value" inline :disabled="objFilterData.srv_inwork.value">В работе</base-checkbox>
							<base-checkbox v-model="objFilterData.srv_sdelka_excl.value" inline :disabled="objFilterData.srv_sdelka.value">Сделка</base-checkbox>
							<base-checkbox v-model="objFilterData.srv_arhiv_excl.value" inline :disabled="objFilterData.srv_arhiv.value">Архив</base-checkbox>
						</div>
					</div>
					<div class="row" v-if="this.objFilterData.rb_service.value != 2">
						<label class="col-form-label col-md-3">По конкретной услуге</label>
						<div class="col-md-9 d-flex">
							<el-select
									class="w-100 px-0 select-primary mb-3"
									v-model="objFilterData.bp_id.value" 
									placeholder="Выбрать услугу"
									size="large"
									clearable
									filterable
								>
								<el-option
									class="select-primary"
									v-for="(el_opt, el_index) in selServOpts"
									:value="el_opt.value"
									:label="el_opt.label"
									:key="el_index" 
								>
								</el-option>
							</el-select>
							<base-button type="danger" class="no-border my-0" simple icon @click="function(){objFilterData.bp_id.value= '';}"><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>

						</div>
					</div>

					<div class="row">
						<label class="col-form-label col-md-3">Время добавления клиента</label>
						<div class="form-group col-md-9">
							<ReStrangeDateRange 
								placeholder="Время добавления клиента"
								v-model="objFilterData.byTimeRange.value"
							/>
						</div>
					</div>

				</div>
				<div class="applyFilter">
					<base-button @click="OnFilterApply()" type="success">Применить</base-button>
				</div>

			</div>
		</card> -->



		<ReClientMultiOp :masClients="masApi" @change="OnFilterApply"/>

		<div class="row" style="align-items: center;">
			<Pagination :class="[{'': parseInt(masApi_total) > 0}, {'d-none': parseInt(masApi_total) < 1}]"
				:type="'info'" 
				:total="parseInt(masApi_total)" 
				:perPage="parseInt(c2p)" 
				:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
				:pClick="pClick">
			</Pagination>

			<div class="d-flex">
				<label><p>Показывать по:</p></label>
				<el-select
					style="margin-top: -5px; width: 80px;"
					class="select-primary overflow-overlay ml-1"
					placeholder="Количество элементов на странице"
					v-model="c2p"
					@change="OnFilterApply"
				>
					<el-option
						v-for="(el_opt, el_index) in c2p_options"
						class="select-primary"
						:value="el_opt.value"
						:label="el_opt.label"
						:key="el_index"
					>
					</el-option>
				</el-select>
			</div>
		</div>
	</div>
</template>
<script>

// import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
import ReClientMultiOp from 'src/our_components/ReClientMultiOp.vue';
import Pagination from 'src/our_components/RePagination';
import { Select, Option, Checkbox } from 'element-ui';
// import { BaseCheckbox, BaseRadio } from 'src/components/index';
// import ReSearchStaffClients from 'src/our_components/ReSearchStaffClients.vue';
// import ReStrangeDateRange from 'src/our_components/ReStrangeDateRange.vue';
import ReClientMultiOpFilter from 'src/our_components/ReClientMultiOpFilter.vue';


export default {
	name: 'Clients_group_op-page',
	components: {
		// ReFilter,
		ReFilterBtn,
		ReClientMultiOp,
		Pagination,
		[Option.name]: Option,
		[Select.name]: Select,
		[Checkbox.name]: Checkbox, 
		// ReSearchStaffClients,
		// BaseCheckbox,
		// BaseRadio,
		// ReStrangeDateRange,
		ReClientMultiOpFilter,
	},
	data() {
		return {
			ApiData: {},
			objApiData:{},
			objGetParams: {},
			bShowFilter: false,
			masApi: [],
			masApi_total:0,
			c2p:50,
			c2p_options:[{'value':10,'label':'10'},{'value':20,'label':'20'},{'value':50,'label':'50'},{'value':100,'label':'100'}],
		};
	},
	computed: {
		
	},
	watch: {
		'$route' (to, from) {
			// console.log(to);
			// console.log(from);
			this.getApi(); // перенёс из OnFilterApply
		}
	},
	methods: {
		getApi(){
			//console.log('getApi',this.objGetParams);
			this.masApi = [];
			let filter = {};
			this.objGetParams = this.$GVO.GetAllGet();
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				filter = this.$GVO.SafeParseJson(JSON.stringify(this.objGetParams));	
			}

			//this.$GVO.ApiCall('GET',{obj:'client' ,flt:{...{list:true}, ...filter,...{c2p:this.c2p}} })
			this.$GVO.ApiCall('GET',{obj:'client' ,flt:{...{list:true},...filter,...{c2p:this.c2p}} })
			.then((objApi) => { 
				//this.masApi;
				this.masApi_total = 0;
				if(objApi.success === true){ //console.log(objApi);
					this.masApi = objApi.data;
					//console.log('total', objApi.sql)
					if(objApi.total!=undefined) { this.masApi_total=objApi.total; }
					//eventEmitter.$emit('OnFilterApply', this.objGetParams);
				}else{
					this.masApi = [];
					this.masApi_total = 0;
					//this.openFullScreen1();
				}
			}).catch((errorObjApi) => {console.error(errorObjApi); this.masObjects_total=0; this.masApi = [];});

		},

		ShowFilter(){
			this.bShowFilter = !this.bShowFilter;
		},
		
		OnFilterApply(strItogGetParams){ // применяет параметры из фильтра и запускает запрос к АПИ
			if(strItogGetParams == undefined){
				let objItogGetParams = this.$GVO.GetAllGet();
				if(typeof objItogGetParams['p'] != 'undefined'){
						delete objItogGetParams['p'];
					}
				strItogGetParams = this.$GVO.ObjToQueryString(objItogGetParams).substr(1);
			}
			// console.log('OnFilterApply++',strItogGetParams);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			this.getApi();
		},
		pClick(e){
			// this.objGetParams['p'] = parseInt(e);
			// this.OnFilterApply();

			let strItogGetParams = '';
			let objItogGetParams = this.$GVO.GetAllGet();
			objItogGetParams.p=parseInt(e);
			strItogGetParams = this.$GVO.ObjToQueryString(objItogGetParams).substr(1);
			this.OnFilterApply(strItogGetParams);
		},

	},
	mounted() {		
		this.getApi();
	}
};
</script>
<style scoped>
/* .majorFilter-card {border: 1px solid #01b0e0;}
.majorFilter {display: flex; justify-content: space-between;} */

</style>
